import { CORPORATE_WORKSPACE_ROUTES, corporatePageFeature } from '../config/corporateNav';
import { isSuperAdminUser } from './userRoles';

function normalizeFeatures(features) {
  if (!Array.isArray(features)) return [];
  return features
    .map((f) => (typeof f === 'string' ? f.trim().toLowerCase() : ''))
    .filter(Boolean);
}

export function formatCorporatePageLabel(feature) {
  if (typeof feature !== 'string' || !feature.startsWith('corporate:')) {
    return feature || '';
  }
  const tabId = feature.slice('corporate:'.length);
  const tab = CORPORATE_WORKSPACE_ROUTES.find((t) => t.id === tabId);
  return tab?.label || tabId;
}

export function isCorporatePageFeature(feature) {
  return typeof feature === 'string' && feature.startsWith('corporate:');
}

/** Tabs visible in the corporate workspace. Super Admin always sees all tabs. */
export function getVisibleCorporateTabs(features, user) {
  if (isSuperAdminUser(user)) {
    return CORPORATE_WORKSPACE_ROUTES;
  }
  const enabled = new Set(normalizeFeatures(features).filter(isCorporatePageFeature));
  if (enabled.size === 0) {
    return [];
  }
  return CORPORATE_WORKSPACE_ROUTES.filter((t) => enabled.has(corporatePageFeature(t.id)));
}

export function isCorporateTabEnabled(tabId, features, user) {
  if (isSuperAdminUser(user)) return true;
  return normalizeFeatures(features).includes(corporatePageFeature(tabId));
}

/** First enabled corporate screen path (profile setup stays at /corporate). */
export function firstAccessibleCorporatePath(features, user) {
  const tabs = getVisibleCorporateTabs(features, user);
  return tabs[0]?.path || '/corporate';
}
